import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import Eyebrow from '../page/Eyebrow';
import StepNumber from '../page/StepNumber';
import { tie } from '../page/typography';

export const stageAnchor = (index) => `etap-${index + 1}`;

/**
 * Увесь шлях одним поглядом — одразу під банером.
 *
 * Банер обіцяє «щоб ви бачили весь шлях наперед», а до першого етапу
 * раніше треба було прогорнути два абзаци й фото на пів екрана; на
 * телефоні — три екрани. Тепер шість етапів стоять рядком одразу, і кожен
 * веде до свого розділу нижче: хто вже має ТОВ і приміщення, стрибає
 * відразу до кадрів.
 *
 * Шість у ряд — лише від xl: на 1024 плитка вужча за «інклюзивність», і
 * слово рвалося б посередині. Нижче — два ряди по три, на телефоні —
 * стовпчик, і лінія між кружками повертається разом із напрямком.
 *
 * Лінії стоять по центру кружка StepNumber size="sm" (32px): рамка плитки
 * 1px + відступ 16px + половина кружка — 33px; лінія завширшки 1px, тож
 * її лівий край на 32,5px.
 */
const LaunchRoute = ({ stages, note }) => (
  <nav aria-labelledby="route-title" className="rounded-2xl border border-slate-100 bg-slate-50 p-5 sm:p-8 lg:p-10">
    <Eyebrow as="h2" id="route-title" className="mb-6">
      {`Увесь шлях · ${stages.length} етапів`}
    </Eyebrow>

    <ol className="list-none grid gap-3 sm:grid-cols-3 xl:grid-cols-6">
      {stages.map((stage, i) => {
        const last = i === stages.length - 1;
        // Кінець ряду з трьох: лінія до наступної плитки тут вела б у порожнечу.
        const rowEnd = (i + 1) % 3 === 0;
        return (
          <li key={stage.number} className="relative">
            {!last && (
              <>
                <span className="sm:hidden absolute left-[calc(2rem+0.5px)] top-full h-3 w-px bg-teal-300" aria-hidden="true"></span>
                <span
                  className={`hidden ${rowEnd ? 'xl:block' : 'sm:block'} absolute left-full top-[calc(2rem+0.5px)] w-3 h-px bg-teal-300`}
                  aria-hidden="true"
                ></span>
              </>
            )}
            <a
              href={`#${stageAnchor(i)}`}
              className="group relative flex h-full min-h-[3.5rem] items-center gap-4 rounded-xl border border-slate-200 bg-white px-4 py-3 sm:flex-col sm:items-start sm:gap-3 sm:p-4 hover:border-teal-300 hover:shadow-md transition-[border-color,box-shadow] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
            >
              <StepNumber
                n={i + 1}
                size="sm"
                variant="soft"
                className="group-hover:bg-teal-700 group-hover:border-teal-700 group-hover:text-white transition-colors duration-200"
              />
              <span className="flex-1 min-w-0 text-[0.95rem] font-semibold leading-snug text-slate-800 group-hover:text-teal-800 transition-colors duration-200">
                {tie(stage.title)}
              </span>
              <Icon
                name="fa-arrow-right"
                className="flex-shrink-0 rotate-90 text-xs text-teal-700 sm:absolute sm:top-[calc(2rem+1px)] sm:-translate-y-1/2 sm:right-4"
              />
            </a>
          </li>
        );
      })}
    </ol>

    <div className="mt-8 pt-6 border-t border-slate-200 flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between lg:gap-10">
      <p className="max-w-3xl text-base leading-relaxed text-slate-600">{tie(note)}</p>
      <Link
        to="/poslugy"
        className="group inline-flex flex-shrink-0 items-center gap-4 self-start lg:self-auto rounded-xl border border-slate-200 bg-white px-5 py-3 hover:border-teal-300 hover:shadow-md transition-[border-color,box-shadow] duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2"
      >
        <span>
          <span className="block text-sm text-slate-600">Потрібен лише один із етапів?</span>
          <span className="block font-semibold text-slate-900 group-hover:text-teal-800 transition-colors duration-200">
            Перелік послуг
          </span>
        </span>
        <Icon name="fa-arrow-right" className="text-teal-700 transition-transform duration-200 group-hover:translate-x-1" />
      </Link>
    </div>
  </nav>
);

export default LaunchRoute;
